export default defineNuxtRouteMiddleware(async () => {
  const { $env } = useNuxtApp();
  const { getRefreshToken, removeRefreshToken, setRefreshTokenCookie } = useAuthToken();
  const { expiresRefreshToken, refreshToken } = getRefreshToken();

  if ($env.isClient) {
    // For client-side, we need to handle Telegram WebApp auth
    // This will run after the page is loaded and Telegram script is available
    if (process.client) {
      // Wait for next tick to ensure Telegram script has loaded
      await nextTick();

      // Check if we're in Telegram WebApp context
      if (window.Telegram?.WebApp?.initData && !refreshToken.value) {
        const { initData } = window.Telegram.WebApp;

        const { body } = await useAuthTelegramDto({
          init_data: initData,
        });

        if (body.data) {
          const { setAuthToken } = useAuthStore();
          const { setRefreshTokenCookie } = useAuthToken();

          setAuthToken(body.data);
          setRefreshTokenCookie(body.data);
        } else {
          console.error("Telegram authentication failed", body);
        }
      }
    }
    return;
  }

  const { setAuthToken } = useAuthStore();

  if (typeof globalThis.Telegram !== "undefined" && globalThis.Telegram?.WebApp?.initData && !refreshToken.value) {
    const { initData } = globalThis.Telegram.WebApp;

    const { body } = await useAuthTelegramDto({
      init_data: initData,
    });

    if (body.data) {
      setAuthToken(body.data);
      setRefreshTokenCookie(body.data);

      return;
    }
  }

  if (refreshToken.value && expiresRefreshToken.value) {
    const dateNow = generateDate();
    const expiresDate = generateDate(expiresRefreshToken.value);
    const diff = expiresDate.diff(dateNow, "day");
    let updateTokenResponseState = false;
    let updateTokenResponseBody: AuthToken | null = null;

    if (diff <= 7) {
      const { body, success } = await useAuthUpdateRefreshTokenDto({
        refresh_token: refreshToken.value,
      });

      if (body.data) {
        setRefreshTokenCookie(body.data);
      }

      updateTokenResponseState = success;
      updateTokenResponseBody = body.data;
    } else {
      const { body, success } = await useAuthUpdateAccessTokenDto({
        refresh_token: refreshToken.value,
      });

      updateTokenResponseState = success;
      updateTokenResponseBody = body.data;
    }

    if (updateTokenResponseBody) {
      const { setAuthToken } = useAuthStore();

      setAuthToken(updateTokenResponseBody);
    }

    if (!updateTokenResponseState) {
      const { createAppLink } = useAppLink();
      const { hash, pathname, search } = useRequestURL();
      const redirectLink = createAppLink("/", "main");
      const redirectToLink = createAppLink(pathname + search + hash, "main");

      removeRefreshToken();

      return navigateTo(
        {
          path: redirectLink,
          query: {
            modal: SHARED_MODAL.AuthLogin,
            [SHARED_URL_QUERY_PARAMETERS.RedirectTo]: redirectToLink,
          },
        },
        {
          external: true,
        },
      );
    }
  }
});
